// promoción descuento en producto A
import { useState, useEffect } from 'react';

import ProductItem from '../Product/ProductItem';
import ProductSelect from '../Product/ProductSelect';

import { getTitle } from '../../../../helpers/admin/productHelper';
import { savePromoToBD } from '../../../../actions/admin/promotion';
import { basicMsg, confirmDialog } from '../../../../actions/swal_msg';
import { getProductPromotions } from '../../../../helpers/admin/promotion/promotionHelper';

import {
    Typography, Grid, TextField, Stack, Button, ToggleButtonGroup, ToggleButton
} from "@mui/material";
import StarPurple500Icon from '@mui/icons-material/StarPurple500';

import { regex_dec, regex_two_dec } from '../../../../constants/regex';
import { PROMO_PRODUCT } from '../../../../constants/shop/promotion/promotion_const';

const PromoThree = ({
    today, promotion, allProducts,
    activePromotion, setActivePromotion,
    otherPromotion, setOtherPromotion
}) => {
    const { promo, start_date, end_date } = promotion;

    const [data, setData] = useState({
        label: 'Descuento (%)',
        maxLength: 5,
        helperText: '% de descuento',
        type: 'Descuento % en producto'
    });
    const { label, maxLength, helperText, type } = data;
    
    // valor de descuento
    const [discount, setDiscount] = useState('');
    // tipo de descuento
    const [alignment, setAlignment] = useState('percentage');
    // producto A seleccionado
    const [productA, setProductA] = useState(PROMO_PRODUCT);
    const { variant_id, title, variant_title, price } = productA;
    
    const setTextData = () => {
        if (alignment === 'fixed')
            setData(e => ({
                ...e, label: 'Descuento ($)',
                maxLength: 10,
                helperText: `$${discount} de descuento (después de IVA)`,
                type: `$${discount} de descuento en ${
                    variant_id ? getTitle(title, variant_title)
                    : 'producto'
                }`
            }));
        else if (alignment === 'percentage')
            setData(e => ({
                ...e, label: 'Descuento (%)',
                maxLength: 5,
                helperText: `${discount}% de descuento`,
                type: `${discount}% de descuento en ${
                    variant_id ? getTitle(title, variant_title)
                    : 'producto'
                }`
            }));
        else
            setData(e => ({
                ...e, label: 'X',
                maxLength: 1,
                helperText: `Descuento incorrecto`,
                type: 'No se reconoce tipo de descuento en producto'
            }));
    };

    // useEffect(() => {
    //     if (alignment === 'fixed') {
    //         if (discount !== '' && !regex_two_dec.test(discount))
    //             setDiscount('');
    //         else
    //             setTextData();
    //     } else if (alignment === 'percentage') {
    //         if (discount !== '' && !regex_num.test(discount))
    //             setDiscount('');
    //         else
    //             setTextData();
    //     } else
    //         setDiscount('');
    // }, [alignment]);

    useEffect(() => {
        setTextData();
    }, [discount, productA, alignment]);
    
    const handleInputChange = ({ target }) => {
        const name = target.name;
        const value = target.value;
        if (name === 'discount') {
            if (value === '' || regex_dec.test(value))
                setDiscount(value);
        }
    };

    const handleAlignment = (event, newAlignment) => {
        if (newAlignment !== null)
            setAlignment(newAlignment);
    };

    // productos A seleccionado, se introdujo descuento
    const validation = () => {
        // valor de descuento a numérico
        const num = Number(discount);
        if (variant_id === '')
            basicMsg('Seleccione producto');
        else if (discount === '')
            basicMsg(alignment === 'fixed' ?
                'Seleccione la cantidad de descuento' :
                'Seleccione el porcentaje de descuento'
            );
        else if (alignment === 'percentage' && (num < 1 || num > 100))
            basicMsg('Porcentaje de descuento es incorrecto');
        else if (alignment === 'fixed') {
            if (!regex_two_dec.test(discount))
                basicMsg('Valor de descuento es incorrecto');
            else if (alignment === 'fixed' && num > price)
                basicMsg('Descuento supera precio de producto');
            else return true
        } else return true;

        return false;
    };

    // verificar si existen promociones con el producto
    const checkPromos = async() => {
        if (validation()) {
            const ActivePromotions = getProductPromotions(promo, activePromotion, otherPromotion, { productA });
            if (ActivePromotions.status) {
                if (await confirmDialog('¿Registrar la promoción?', ActivePromotions.html, 'Registrar'))
                    savePromo();
            } else savePromo();
        }
    };

    // guardar promoción del producto
    const savePromo = async () => {
        // Number(discount)
        const Model = {
            ...promotion,
            discount,
            discount_type: alignment,
            variant_a: {
                _id: variant_id,
                title, variant_title
            }
        };
        const req = await savePromoToBD(Model, 'save-promo-three');
        if (req.status) {
            const { _id } = req.resp;
            // promoción activa
            if (start_date <= today && end_date >= today)
                setActivePromotion(e => ([
                    ...e, { _id, ...Model }
                ]));
            else // promoción guardada (no activa)
                setOtherPromotion(e => ([
                    ...e, { _id, ...Model }
                ]));
            // limpiar campos
            setProductA(PROMO_PRODUCT);
            setDiscount('');
        }
    };

    return (
        <Grid container spacing={6}>
            <Grid item xs={12}>
                <Stack
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={2}
                    sx={{ mb: 2 }}>
                    <Typography variant="h6">
                        { `Promoción: ${type}` }
                    </Typography>
                    <StarPurple500Icon />
                </Stack>

                <Grid container spacing={4}>
                    {
                        variant_id !== '' &&
                            <ProductItem
                                product={productA}
                                setProduct={setProductA}
                                alt={'producto-A'}
                                text={'Producto seleccionado'}
                            />
                    }
                </Grid>

                <ToggleButtonGroup
                    sx={{ mt: 2 }}
                    color="primary"
                    value={ alignment }
                    exclusive
                    onChange={ handleAlignment }
                    aria-label="discount"
                    >
                    <ToggleButton value="type" disabled>Tipo descuento</ToggleButton>
                    <ToggleButton value="percentage">%</ToggleButton>
                    <ToggleButton value="fixed">$</ToggleButton>
                </ToggleButtonGroup>

                <TextField fullWidth
                    sx={{ mt: 1 }}
                    name="discount"
                    label={ label }
                    variant="standard"
                    inputProps={{ maxLength }}
                    helperText={ helperText }
                    value={ discount }
                    onChange={ handleInputChange }
                />

                {
                    variant_id !== '' &&
                        <Button sx={{ mt: 1 }}
                            variant="contained"
                            onClick={ checkPromos }>
                            Guardar promoción
                        </Button>
                }

                <ProductSelect
                    text={''}
                    setProduct={setProductA}
                    allProducts={allProducts}
                />
            </Grid>
        </Grid>
    );
};

export default PromoThree;